export enum DISPATCH_STATUS {
  ACCEPTED = 'Accepted',
  NEW = 'New',
  CANCELLED = 'Canceled',
  EXPIRED = 'Expired',
}
